module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Originally from the north of England, David Peart now lives in a village in Essex with his three daughters. He is a widowed husband to Joanne, who died in July 2019.")]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("He has previously written two children’s books to help his daughters during their grieving process. "), _c('em', [_vm._v("I Want to Hug Mummy")]), _vm._v(", and "), _c('em', [_vm._v("It’s Okay to Feel Happy")]), _vm._v(" are now being used to help other children and families who have experienced loss. That inspired him to write a book from his point of view that can help other people who have related experiences—not just bereavement but other disruptive events.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0235a5e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0